import React from "react";

const About = () => {
  return (
    <section id="about" className="section">
      <div className="card">
        <h2>About Me</h2>
        <p>
          B.Tech AI/ML student with strong skills in Data Structures, Machine Learning,
          and Full Stack Development.
        </p>
        <p>
          Passionate about building intelligent systems and solving real-world problems.
        </p>
      </div>
    </section>
  );
};

export default About;